export default {
  features: {
    viewRealTimeNotifications: {
      link: 'Batafsil',
    },
  },
};
